import { compose, lifecycle, withHandlers } from 'recompose'
import R from 'ramda'

export const checkRerenders = (label) =>
  lifecycle({
    componentDidMount(props) {
			console.log('mount')
      console.log(
        '%c' + (label ? `${label} was mounted!` : 'Mounted!'),
        'font-weight: bold; background: #eee;'
      )
    },
    componentDidUpdate(pProps) {
      console.log(
        '%c' + (label ? `${label} was rerendered!` : 'Rerender!'),
        'font-weight: bold; background: #eee;'
      )

      const keys = R.uniq(Object.keys(this.props).concat(Object.keys(pProps)))
      keys.forEach((key) => {
        if (this.props[key] === pProps[key]) {
          console.log(`%cprop "${key}" didn't change.`, 'background: #eee;')
        } else {
          console.log(
            `%cprop "${key}" changed!`,
            'color: red; background: #eee;'
          )
          console.log({
            [`previous ${key}`]: pProps[key],
            [`current ${key}`]: this.props[key]
          })
        }
      })
    }
  })

export const logProps = (str, pickArr) =>
  compose(
    withHandlers({
      logProps: (props) => () => {
        const logged = pickArr ? R.pick(pickArr)(props) : props
        console.log(str, logged)
      }
    }),
    lifecycle({
      componentDidMount() {
        this.props.logProps()
      },
      componentDidUpdate() {
        this.props.logProps()
      }
    })
  )



// WEBPACK FOOTER //
// ./src/components/common/enhancers.js